import { GenericList } from "../commons/generic.responses";

export const States: GenericList[] = [
    { id: 'AK', descr: 'Alaska' },
    { id: 'AL', descr: 'Alabama' },
    { id: 'AR', descr: 'Arkansas' },
    { id: 'AZ', descr: 'Arizona' },
    { id: 'CA', descr: 'California' },
    { id: 'CO', descr: 'Colorado' },
    { id: 'CT', descr: 'Connecticut' },
    { id: 'DE', descr: 'Delaware' },
    { id: 'FL', descr: 'Florida' },
    { id: 'GA', descr: 'Georgia' },
    { id: 'HI', descr: 'Hawaii' },
    { id: 'IA', descr: 'Iowa' },
    { id: 'ID', descr: 'Idaho' },
    { id: 'IL', descr: 'Illinois' },
    { id: 'IN', descr: 'Indiana' },
    { id: 'KS', descr: 'Kansas' },
    { id: 'KY', descr: 'Kentucky' },
    { id: 'LA', descr: 'Louisiana' },
    { id: 'MA', descr: 'Massachusetts' },
    { id: 'MD', descr: 'Maryland' },
    { id: 'ME', descr: 'Maine' },
    { id: 'MI', descr: 'Michigan' },
    { id: 'MN', descr: 'Minnesota' },
    { id: 'MO', descr: 'Missouri' },
    { id: 'MS', descr: 'Mississippi' },
    { id: 'MT', descr: 'Montana' },
    { id: 'NC', descr: 'North Carolina' },
    { id: 'ND', descr: 'North Dakota' },
    { id: 'NE', descr: 'Nebraska' },
    { id: 'NH', descr: 'New Hampshire' },
    { id: 'NJ', descr: 'New Jersey' },
    { id: 'NM', descr: 'New Mexico' },
    { id: 'NV', descr: 'Nevada' },
    { id: 'NY', descr: 'New York' },
    { id: 'OH', descr: 'Ohio' },
    { id: 'OK', descr: 'Oklahoma' },
    { id: 'OR', descr: 'Oregon' },
    { id: 'PA', descr: 'Pennsylvania' },
    { id: 'RI', descr: 'Rhode Island' },
    { id: 'SC', descr: 'South Carolina' },
    { id: 'SD', descr: 'South Dakota' },
    { id: 'TN', descr: 'Tennessee' },
    { id: 'TX', descr: 'Texas' },
    { id: 'UT', descr: 'Utah' },
    { id: 'VA', descr: 'Virginia' },
    { id: 'VT', descr: 'Vermont' },
    { id: 'WA', descr: 'Washington' },
    { id: 'WI', descr: 'Wisconsin' },
    { id: 'WV', descr: 'West Virginia' },
    { id: 'WY', descr: 'Wyoming' },
];